import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Rightarrow from "../assets/icons/Rightarrow";
import Lock from "../assets/icons/Lock";
import { get } from "../network/api";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const Pricing = () => {
const {  i18n } = useTranslation();
    const currentLanguage = i18n.language; // e.g. "en", "lv"

  const [listings, setListings] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);  

  useEffect(  () => {
    // Fetch data from API endpoint
    getPlans();
  }, []); 

  async function getPlans() { 
    
    
    try {
      const data = await get('customer/get-subscription',)
      
      setListings(data); // Store data in state
      setLoading(false);
    }
    catch (e) { 
        // setError(error.message); // Handle any errors
        setLoading(false);
    }
  }




  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className="pricing_section">
      <div className="wrapper">
        <div className="pricing_title">
          <h2 className="subtitle_common">
            {t("customizable")}{" "}
            <span className="text-secondary">{t("solutions_for_partners")}</span>
          </h2>
          <p className="para_common">
            {t("unlock_new_revenue_streams_and_reach_a_wider_customer_base_by_partnering_with_us")}
          </p>
        </div>
        <div className="pricing_slider">
          <Swiper
            spaceBetween={40}
            slidesPerView={3}
            centeredSlides={true}
            autoplay={{ delay: 3000 }}
            navigation={true}
            loop={true}
            modules={[Navigation, Autoplay]}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            breakpoints={{
                320: {
                  slidesPerView: 1.2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
            className="pricing_swiper"
          >
            {listings.map((plan, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`pricing_card ${index === 1 ? "active_plan" : ""}`}
                >
                  <div className="pricing_card_number">{`0${index+1}`}</div>
                  <div className="pricing_card_content">
                    <h3 className="pricing_name">{plan.name}</h3>
                    <p className="pricing_desc">{plan.price}€ per month + 21% TAX</p>
                    <ul className="pricing_list">
                      
                      <li>
  {currentLanguage === "en"
    ? `Includes ${plan?.free_orders} order per month, additional orders are at ${plan?.extra_price_per_order} per order`
    : `Ietver ${plan?.free_orders} pasūtījumu mēnesī, papildu pasūtījumi maksā ${plan?.extra_price_per_order} par pasūtījumu`}
</li>

                      
                      {(currentLanguage === "en"
    ? plan?.offers
    : plan?.offers_lv
  )?.map((offer, index) => (
    <li key={index}>{offer}</li>
  ))}
                    
                    </ul>
                    <button
                      className={`btn ${
                        index === activeIndex ? "btn-primary" : "btn-secondary"
                      }`}
                    >
                       Choose Plan {plan.status === "locked" ? <Lock /> : <Rightarrow />}
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
